export const Chevron = () => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M279.5 80.3c-13.7 4.6-22.7 13.4-26.7 25.9-1.5 5.1-1.8 9.4-1.8 30.2v24.2l-104.7 31.8c-141.4 43-125.6 37.8-131.9 44-11.3 11.4-11.3 27.8 0 39.2 6.3 6.2-9.3 1 131.9 44L251 351.4v24.2c0 20.8.3 25.1 1.8 30.2 3.5 11 10.4 18.6 21.9 24 5.1 2.4 7 2.7 15.8 2.7s10.7-.3 15.7-2.7c6-2.8 179.1-137.2 187.9-145.9 14.5-14.3 15.7-36.6 2.8-52.9-4.1-5.3-181.5-143.8-189.4-147.9-5.8-3.1-7.6-3.5-15.3-3.8-5.3-.2-10.2.2-12.7 1z"/>
        </svg>
    )
}